module.exports = __webpack_public_path__ + "static/eucnc_demo-84f9b0ef499c3d93ad8f93f2543469bb.jpg";